import { OptionItem } from "@interface48/api";
import { JsonSchema, JsonSchemaDefinition, JsonSchemaType } from "../models";

export const getSchemaOptions = <T extends string | number>(schema: JsonSchema) => {
  let options: Array<OptionItem<T>> = [];

  if (schema.type === "array") {
    if ((schema.items as any).oneOf) {
      options = getAltSchemasOptionsHelper((schema.items as any).oneOf);
    } else if ((schema.items as any).anyOf) {
      options = getAltSchemasOptionsHelper((schema.items as any).anyOf);
    } else if ((schema.items as any).enum) {
      const enums = (schema.items as any).enum;
      const enumNames = (schema.items as any).enumNames;
      options = getEnumSchemaOptionsHelper(enums, enumNames);
    }
  } else if (schema.enum) {
    const enums = schema.enum;
    const enumNames = (schema as any).enumNames;
    options = getEnumSchemaOptionsHelper(enums, enumNames);
  } else if (schema.oneOf) {
    options = getAltSchemasOptionsHelper(schema.oneOf);
  } else if (schema.anyOf) {
    options = getAltSchemasOptionsHelper(schema.anyOf);
  }
  return options;
};

const getEnumSchemaOptionsHelper = <T extends string | number>(
  schemaEnum: JsonSchemaType[],
  schemaEnumNames?: any[],
) => {
  const options: Array<OptionItem<T>> = [];
  schemaEnum.forEach((enumItem: JsonSchemaType, index: number) => {
    // JsonSchema has no definition for enumNames therefore cast to any...
    const enumNames = schemaEnumNames;
    options.push({
      value: enumItem as T,
      label: enumNames ? enumNames[index] + "" : enumItem + "",
    });
  });

  return options;
};

// altSchemaEnum = anyOf | oneOf
const getAltSchemasOptionsHelper = <T extends string | number>(altSchemaEnum: JsonSchemaDefinition[]) => {
  const options: Array<OptionItem<T>> = [];
  altSchemaEnum.forEach((enumItem: JsonSchemaDefinition, index: number) => {
    if (typeof enumItem !== "boolean") {
      const enumValue = (enumItem.enum && (enumItem.enum[0] as T)) || (enumItem.const as T);
      const enumTitle = enumItem.title + "" || enumValue + "";
      options.push({
        value: enumValue,
        label: enumTitle,
      });
    }
  });

  return options;
};
